// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__StG44","property_image":"styles_property_image__rZ5zn"};